const YOUTUBE_HOSTS = ["youtube.com", "youtu.be"];

function isYouTubeUrl(url) {
  try {
    const { hostname } = new URL(url);
    return YOUTUBE_HOSTS.some((host) => hostname.endsWith(host));
  } catch {
    return false;
  }
}

function extractYouTubeId(url) {
  const patterns = [
    /(?:youtube\.com\/.*[?&]v=)([^&\n?#]+)/,
    /youtu\.be\/([^&\n?#]+)/,
    /youtube\.com\/embed\/([^&\n?#]+)/,
  ];
  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match) return match[1];
  }
  return null;
}

/**
 * Is this an iframe-embeddable video page (e.g. a YouTube embed URL),
 * as opposed to a direct playable video file (local upload or the
 * videos. subdomain), which should be rendered with a native <video> tag.
 */
export function isEmbedVideoUrl(url) {
  return typeof url === "string" && url.includes("youtube.com/embed");
}

/**
 * Normalize a raw video url coming from the API into something the
 * frontend can render directly:
 * - YouTube links (watch/share/embed) -> youtube.com/embed/<id>
 * - Any other absolute http(s) url (e.g. the videos. subdomain) -> unchanged
 * - Relative path -> prefixed with VITE_VIDEOS_BASE_URL
 */
export function resolveVideoUrl(rawUrl) {
  if (!rawUrl || rawUrl === "null") return rawUrl ?? null;

  if (isYouTubeUrl(rawUrl)) {
    const id = extractYouTubeId(rawUrl);
    return id ? `https://www.youtube.com/embed/${id}` : rawUrl;
  }

  if (/^https?:\/\//i.test(rawUrl)) return rawUrl;

  const videosBaseUrl = import.meta.env.VITE_VIDEOS_BASE_URL ?? "";
  return `${videosBaseUrl}${rawUrl}`;
}

/**
 * Resolve the `url` field of every image row nested inside a product's
 * `imagenPresentaciones` (one array of image rows per presentation).
 */
export function resolveImagenPresentaciones(imagenPresentaciones) {
  if (!Array.isArray(imagenPresentaciones)) return imagenPresentaciones;

  return imagenPresentaciones.map((rows) =>
    Array.isArray(rows)
      ? rows.map((row) =>
          row ? { ...row, url: resolveVideoUrl(row.url) } : row
        )
      : rows
  );
}
